import { Component } from '@angular/core';

@Component({
  selector: 'app-security-container',
  templateUrl: './security-container.component.html',
  styleUrls: ['./security-container.component.scss']
})
export class SecurityContainerComponent {

}
